import React, { useEffect, useState, useContext } from 'react';
import { baseUrl } from '../../Contants';
import {
  useHistory,
  useLocation,
  withRouter,
  Link,
  Redirect,
} from 'react-router-dom';

// MUI
import {
  InputAdornment,
  OutlinedInput,
  IconButton,
  Button,
  Typography,
} from '@material-ui/core';

// Context
import { AppContext } from '../../Context/AppContextProvide';
import { AlertContext } from '../../Context/AlertContextProvider';
import { CompanyLogoContext } from '../../Context/CompanyLogoContextProvider';

// CSS
import '../styles/Signin.css';
import {
  login,
  getCustomerCreateAccountStatus,
  startGoogleAuth,
  // startMicrosoftAuth, // Microsoft login hidden until ready
} from '../../Actions';

// Login buttons
import GoogleButton from './GoogleButton';
// import MicrosoftButton from './MicrosoftButton'; // Microsoft login hidden until ready

// Icons
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const Signin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState('password');
  const { setAuthType, setAccessToken, user } = useContext(AppContext);
  const { handleAlertOpen, setMessageType, setMessage } =
    useContext(AlertContext);
  const history = useHistory();
  const [newUserAccountRegStatus, setNewUserAccountRegStatus] = useState(0);

  useEffect(() => {
    async function getCreateAccountStatus() {
      await getCustomerCreateAccountStatus().then((result) => {
        setNewUserAccountRegStatus(Number(result.data.data[0].app_value));
      });
    }

    getCreateAccountStatus();
  }, []);

  const handleUsernameChange = (e) => setUsername(e.target.value);

  const handlePasswordChange = (e) => setPassword(e.target.value);

  const handleKeyPress = (target) => {
    if (target.charCode === 13 && !isDisabled()) {
      onSubmit();
    }
  };

  const onSubmit = () => {
    // let now = new Date();
    login(username, password)
      .then((result) => {
        setAuthType('local');
        setAccessToken(result.data.token);

        localStorage.setItem('accessToken', result.data.token);
        localStorage.setItem('authType', 'local');
        localStorage.setItem('tokenExpiration', result.data.will_expire_at);

        const returnUrl = localStorage.getItem('returnUrl');

        setTimeout(() => {
          history.push(returnUrl || '/home');
          localStorage.removeItem('returnUrl');
        }, 500);
      })
      .catch((err) => {
        setMessageType('error');
        setMessage('Invalid username/password');
        handleAlertOpen(true);
      });
  };

  const isDisabled = () => {
    return !(username.length && password.length);
  };

  const handleClickShowPassword = () => {
    showPass === 'password' ? setShowPass('text') : setShowPass('password');
  };

  const initiateGoogleAuth = async () => {
    const { data: authorizationUrl } = await startGoogleAuth();

    if (!authorizationUrl) {
      return;
    }

    window.location.href = authorizationUrl;
  }

  // Microsoft login hidden until ready
  // const initiateMicrosoftAuth = async () => {
  //   const { data: authorizationUrl } = await startMicrosoftAuth();
  //
  //   if (!authorizationUrl) {
  //     return;
  //   }
  //
  //   window.location.href = authorizationUrl;
  // }

  // Already logged in? Don't show the login page — go straight to home.
  if (new Date().getTime() < user?.will_expire_at) {
    return <Redirect to="/home" />;
  }

  return (
    <div className="signin__container">
      <div className="signin__local" onKeyPress={handleKeyPress}>
        <div className="signin__container-header">
          <Typography
            variant="h2"
            align="center"
            className="signin__header-text"
          >
            Login
          </Typography>
        </div>
        <label className="register__label" htmlFor="confirm_pwd">
          User Name:
        </label>
        <OutlinedInput
          value={username}
          onChange={handleUsernameChange}
          className="signin__username"
          variant="outlined"
          type="text"
        />
        <label className="register__label" htmlFor="confirm_pwd">
          Password:
        </label>
        <OutlinedInput
          value={password}
          onChange={handlePasswordChange}
          className="signin__password"
          label="password"
          type={showPass}
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword}>
                {showPass === 'text' ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
        <div>
          <hr />
        </div>
        <div className="signin_local-btn-container">
          <Button
            disabled={isDisabled()}
            onClick={onSubmit}
            className="sigin__local-btn"
            variant="contained"
          >
            Login
          </Button>
        </div>
        <div
          className="signin__google"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <GoogleButton onClick={() => initiateGoogleAuth()} />
          {/* Microsoft login hidden until ready
          <div style={{ marginTop: 10 }}>
            <MicrosoftButton onClick={() => initiateMicrosoftAuth()} />
          </div>
          */}
        </div>
        <div
          style={{
            textAlign: 'center',
            textDecoration: 'none',
            marginBottom: 25,
          }}
        >
          {newUserAccountRegStatus === 1 ? (
            <span>
              <Link
                to="/forgotpass"
                style={{
                  textDecoration: 'none',
                  color: '#4E564E',
                  fontSize: 15,
                }}
              >
                Forgot Password?
              </Link>
              {'  |  '}
              <Link
                to="/register"
                style={{
                  textDecoration: 'none',
                  color: '#4E564E',
                  fontSize: 15,
                }}
              >
                New User
              </Link>
            </span>
          ) : (
            <Link
              to="/forgotpass"
              style={{ textDecoration: 'none', color: '#4E564E', fontSize: 15 }}
            >
              Forgot Password?
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Signin);
